import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RegistrationService } from 'src/app/services/registration.service';
import { RegistrationVerify } from 'src/app/models/registration-verify.model';
// import * as $ from 'jquery';

@Component({
  selector: 'app-registration-verify-list',
  templateUrl: './registration-verify-list.component.html',
  styleUrls: ['./registration-verify-list.component.scss']
})
export class RegistrationVerifyListComponent implements OnInit, OnDestroy, AfterViewInit {
  id: any;
  registrationVerifies: RegistrationVerify[];
  registrationVerifyMulti: RegistrationVerify = new RegistrationVerify();
  today: any;
  constructor(private registrationService: RegistrationService, private router: Router) { }
  intervalList: any;
  items = [];
  pageSize: number = 50;
  count: any = 0;
  page: any = 1;
  checkAll: any;
  isDeleteMulti = true;
  ngOnInit(): void {
    this.loadRegistrationVerify();
    // this.intervalList = setInterval(() => {
    //   this.loadRegistrationVerify();
    // }, 60000);
  }

  loadRegistrationVerify() {
    this.today = Date.now();
    this.registrationService.getRegistrationVerifies().subscribe(data => {
      this.registrationVerifies = data;
      this.count = data.length;
      if (this.registrationVerifies && this.registrationVerifies.length > 0) {
        this.registrationVerifies.map((obj) => {
          obj['checked'] = false;
          return obj;
        })
      }
    });
  }

  create(registrationVerify: RegistrationVerify) {
    this.registrationService.createRegistrationVerify(registrationVerify);
  }

  update(registrationVerify: RegistrationVerify) {
    this.registrationService.updateRegistrationVerify(registrationVerify);
  }

  delete(id: string, declarationNumber: string) {
    if (confirm("Bạn có chắc chắn muốn xóa tờ khai số " + declarationNumber + " ? ")) {
      this.registrationService.deletePolicy(id);
    }
  }

  viewDetails(id: string) {
    this.router.navigateByUrl("/chi-tiet-dang-ky-kiem-hoa/" + id);
  }

  exportExcel() {
    this.registrationService.exportExcel(this.registrationVerifies, "danh-sach-dang-ky-kiem-hoa");
  }

  deleteMulti() {
    let lstChecked = this.registrationVerifies.filter(item => { return item.checked == true; });
    if (confirm("Bạn có chắc chắn muốn xóa những tờ khai này? ")) {
      let lstId = lstChecked.map(({ id }) => id);
      this.registrationService.deleteMultiPolicy(lstId);
      this.isDeleteMulti = true;
    }
  }

  replyMulti() {
    let listRegistrationVerifyChecked = this.registrationVerifies.filter(item => { return item.checked == true; });
    this.registrationService.replyMulti(this.registrationVerifyMulti, listRegistrationVerifyChecked);
    this.registrationVerifyMulti = new RegistrationVerify();
    this.isDeleteMulti = true;
  }

  closeModal() {
    this.registrationVerifyMulti = new RegistrationVerify();
  }

  checkedItem() {
    let lstChecked = this.registrationVerifies.filter(item => { return item.checked == true; });
    this.isDeleteMulti = lstChecked && lstChecked.length > 0 ? false : true;
  }

  deleteOldData(){
    let dateOldData = new Date('04/15/2024'); // mm/dd/yyyy - 40 days 
    let lstOldData = this.registrationVerifies.filter(item => { return item.createdDate <= dateOldData; });
    let lstId = lstOldData.map(({ id }) => id);
    // this.registrationService.deleteMultiPolicy(lstId);
  }

  ngOnDestroy() {
    if (this.intervalList) {
      clearInterval(this.intervalList);
    }
  }

  ngAfterViewInit() {
    // $(document).ready(function() {
    //   $('[data-toggle="tooltip"]').tooltip();
    // });
  }

  onChangePage(event): void {
    this.page = event;
    this.loadRegistrationVerify();
  }
}
